import { render } from "./LoginView.vue?vue&type=template&id=4d89b450&scoped=true"
import script from "./LoginView.vue?vue&type=script&lang=js"
export * from "./LoginView.vue?vue&type=script&lang=js"

import "./LoginView.vue?vue&type=style&index=0&id=4d89b450&scoped=true&lang=css"

import exportComponent from "../../../../../../../../2026-11-02/referenced-chatgpt-conversation-this-is-an-4/outputs/docker-delivery-user-management/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d89b450"]])

export default __exports__